/**
 * @fileoverview Defines controller routes accessed by the Listings Launch UI
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */

import {route} from '/js/yext/storm/router';

export const Routes = {
  // SMB Routes

  // Match Routes
  getGoogleGroups: route('launchlistings/groups'),
  validateGoogleGroup: route('launchlistings/validateGroup'),
  getGoogleMatches: route('launchlistings/matches'),
  getValidateStoreCodeMatch: route('launchlistings/storeCode'),

  // Verification Routes
  getVerificationMethods: route('launchlistings/verification/methods'),
  submitVerificationToPublisher: route('launchlistings/verification/submit'),
  requestVerificationFromPublisher: route('launchlistings/verification/request'),
  getCompletedVerification: route('launchlistings/verification/verified'),

  // Final Submission Routes
  launchListings: route('launchlistings/apply'),

  // Enterprise Routes

  // Select Entities Routes
  getSavedFilters: route('listings/publishers/launchlistings/savedFilters'),

  // Select Features Routes
  getLicensePacks: route('listings/publishers/launchlistings/licensePacks'),

  // Specify Listings Config Routes
  getListingConfig: route('listings/publishers/launchlistings/listingConfig'),

  // Set Up Publisher Routes
  getGbpGroups: route('listings/publishers/launchlistings/gbp/linkedaccount/groups'),
  getGbpGroupLocations: route('listings/publishers/launchlistings/gbp/linkedaccount/locations'),
  getSyncedFields: route('listings/publishers/launchlistings/syncedfieldstable/fields'),
  getSyncedFieldSettings: route('listings/publishers/launchlistings/syncedfieldstable/settings'),
  validateFacebookBrand: route('listings/publishers/launchlistings/facebook/validatebrand'),
  validateGbpGroup: route('listings/publishers/launchlistings/gbp/validategroup'),
  getAppleCountryInfos: route('listings/publishers/launchlistings/apple/getcountryinfos'),

  // Submission Routes
  submit: route('listings/publishers/launchlistings/submit'),

  // Other Routes
  allListings: route('listings/all'),
  publishers: route('listings/publishers'),
  entities: route('entities2'),
  savedFilters: route('account/savedFilters'),
};
